import {
  AnalysisAutomationTaskUpdateInput,
  AutomationTaskInput
} from 'generated-graphql/types';
import { AnalysisAutomationItem } from 'modules/analyse/types/AutomationTasks';
import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';

export type AutomationTaskActions = {
  automationTasksToCreate: AutomationTaskInput[];
  automationTasksToDelete: string[];
  automationTasksToUpdate: AnalysisAutomationTaskUpdateInput[];
};

export const formatAutomationTasksForSubmission = (
  automationTasks: AutomationFormItem[],
  initialAutomationTasks: AnalysisAutomationItem[]
): AutomationTaskActions => {
  const automationTasksToCreate = automationTasks
    .filter((task) => !task.id && task.action.type)
    .map<AutomationTaskInput>((task) => ({
      action: task.action,
      requirementConditions: task.requirementConditions
    }));

  const automationTasksToUpdate = automationTasks
    .filter((task) => {
      if (!task.id) return false;
      const initialTask = initialAutomationTasks.find(
        (initialTask) => initialTask.id === task.id
      );
      return (
        initialTask &&
        JSON.stringify(initialTask) !== JSON.stringify(task) &&
        task.action.type
      );
    })
    .map(
      (task) =>
        ({
          action: task.action,
          requirementConditions: task.requirementConditions,
          id: task.id as string
        } as AnalysisAutomationTaskUpdateInput)
    );

  const automationTasksToDelete = initialAutomationTasks
    .filter((task) => !automationTasks.find((t) => t.id === task.id))
    .map((task) => task.id as string);

  return {
    automationTasksToCreate,
    automationTasksToDelete,
    automationTasksToUpdate
  };
};
